import Panel from '../components/panel'
import {Button} from '../components/button'
import PropertyInput from "../components/inputs/input-property.tsx";

import { useStore } from "../state/state.ts";
import { MEASURE_WIDGET_SOLARTHERMIE } from "../state/measures.tsx";

import { round_to_1000 } from "../functions.ts";
import { useEffect } from "react";
import ModalConfirmButton from '../components/modal_close_button.tsx';

export default function ModalSolarthermieFuture() {
    const pop_modal = useStore((state)=>state.pop_modal);
    const close_menu = useStore((state) => state.close_menu);
    const api_recalculate = useStore((state) => state.api_recalculate);
    const init_property_if_undefined = useStore((state) => state.init_property_if_undefined);
    const financial_plan_dummy = useStore((state)=>state.financial_plan_dummy);

    const solarthermie_future = useStore((state)=>state.solarthermie_future);    
    const api_get_costs = useStore((state)=>state.api_get_costs);
    useEffect(()=>{
        api_get_costs("solar_thermal",solarthermie_future);
    },[solarthermie_future]);

  return (<Panel >
            <h1 id="modal-title">Welche neue Solarthermieanlage ist geplant?</h1>
            <PropertyInput type="solarthermie_future"/>
            <PropertyInput type="solarthermie_orientation_future"/>
            <PropertyInput type="solarthermie_kollektorflaeche_future"/>
            <PropertyInput type="solarthermie_roof_pitch_future"/>
            <PropertyInput type="solarthermie_kosten" placeholder_prefix={"optional ca."} placeholder_override={round_to_1000(financial_plan_dummy["solar_thermal"].total_costs) + " €"}/>

           <ModalConfirmButton  onClick={()=>{
                close_menu();
                init_property_if_undefined("solarthermie_future");
                api_recalculate();
                pop_modal();
            }}/>
         </Panel>)
}